import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect } from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class DrowsinessSchedulesAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      applicabilities_list: [],
      staff_list: [],
      date_start: '',
      date_finish: '',
      send_hours: '',
      name: '',
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChangeApplicability(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aplicabilidade/colaboradores/listagens/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({staff_list: responseJson.data.staffs});
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/parametros-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({applicabilities_list: responseJson.data.applicabilities});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  add(event) {
    event.preventDefault();
    this.handleAlert(this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.aguardeEnquantoAEscalaGerada, 'warning', 'open');
    var datasave = {
      name: this.state.name,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      send_hours: this.state.send_hours,
      applicability_id: this.state.applicability_id,
      staff_id: this.state.staff_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/escala/sonolencia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/escala/sonolencia/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
    
      <h3 className="page-title">{this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.titulo}</h3>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.NomeDaEscalaDeSonolencia} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.HorariosDeEnvio}:</label>
              <input type="text" name="send_hours" className="form-control" placeholder={this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.HorariosDeEnvio} value={this.state.send_hours} onChange={this.handleChange.bind(this, 'send_hours')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} required maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeApplicability.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
          {this.state.applicability_id === 1 ? 
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.Tripulantes}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.SelecionarAplicabilidade}
                  onChange={this.handleSelectChangeMulti.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                  multi={true}
                />
              </div>
            </div>
            : this.state.applicability_id === 2 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.Mecanicos}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.SelecionarAplicabilidade}
                  onChange={this.handleSelectChangeMulti.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                  multi={true}
                />
              </div>
            </div>
            : this.state.applicability_id === 3 ?
            <div className="col-md-6">
              <div className="form-group">
                <label>{this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.Coordenadores}:</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.SelecionarAplicabilidade}
                  onChange={this.handleSelectChangeMulti.bind(this, 'staff_id')}
                  options={this.state.staff_list}
                  multi={true}
                />
              </div>
            </div>
            :
            ''
          }
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.botaoAdicionarEscalaDeTeste}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default DrowsinessSchedulesAdd;



// WEBPACK FOOTER //
// ./src/Components/DrowsinessSchedules/DrowsinessSchedulesAdd.js